import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import ProductCardQuickAdd from "../Components/ProductCard.QuickAdd";
import * as gtmService from "./Gtm.service"
import { post } from "./http";

const ELEMENTS_BOUND_TO_CLICK_LISTENER = []

export const getQuickAddData = (elem) => ({
    sizeModels: Array.from(elem.children).map(e => e.dataset),
    sizeHintValue: elem.dataset["sizeHintValue"],
    sizeHintShort: elem.dataset["sizeHintShort"],
});

export const renderQuickAddComponents = (productListElement) => {
    for(let quickAddElem of productListElement.querySelectorAll(".product__quick-add-container:not([data-loaded=true])")) {
        quickAddElem.dataset["loaded"] = true;
        ReactDOM.render(
            <Provider store={window.__litium.store}>
                <ProductCardQuickAdd {...getQuickAddData(quickAddElem)} />
            </Provider>,
            quickAddElem
        );
    }
}

export const addOnClickEventListeners = (productListElement) => {
    for(let productElem of productListElement.querySelectorAll(".product-list__item")) {
        if(ELEMENTS_BOUND_TO_CLICK_LISTENER.includes(productElem)) continue;

        var gtmProduct = null;
        let productUrl = null;

        try {
            let gtmProductElem = productElem.querySelector("json-data#gtm-product");
            gtmProduct = JSON.parse(gtmProductElem.innerText);
            let productData = productElem.querySelector("script")
            let parsedData = JSON.parse(productData.innerText)
            productUrl = parsedData.Url;
            
        } catch (e) {
            continue;
        }

        if(!gtmProduct || !productUrl){
            continue;
        }

        let list = productElem.querySelector(".product_wrapper");

        for(let anchorElem of productElem.querySelectorAll("a")) {
            anchorElem.addEventListener("click", function(e) {
                productUrl = this.href;

                const isCtrlOrCmdPressed = e.metaKey || e.ctrlKey;
              
                if (!isCtrlOrCmdPressed) {
                    e.preventDefault();
                }
                
                const clickObject = {
                    products: [gtmProduct]
                }

                if(list) {
                    clickObject["actionField"] = { list }
                }

                gtmService.pushEcommerce({
                    event: 'productClick',
                    ecommerce: {
                        currencyCode: gtmService.getCurrency(),
                        click: clickObject,
                    },
                    eventCallback: () => {
                        if (productUrl && !isCtrlOrCmdPressed) {
                            window.location = productUrl;
                        }
                    },
                    eventTimeout: 100
                });
            });
        }
        ELEMENTS_BOUND_TO_CLICK_LISTENER.push(productElem);
    }
}

export const subcribeToBackInStock = async (articleNumber, email) => {
    return post("/api/backinstock", { articleNumber, email });
}